import type { EABLoadBoardEventsQuery, EABLoadBoardQuery } from "@/graphql";

export type EABEventType = EABLoadBoardEventsQuery["SQDCEvents"][0] & { originalBoardId?: number };

export type EABEventActionType = NonNullable<EABEventType["ActionEventConnection"][0]["action"]>;

export type EABEventActionConfigType = EABLoadBoardQuery["SQDCEventActionTypes"][0];

export type EABEventActionTypeCard = EABEventActionConfigType["Cards"][number];

export type EABEventTypeType = EABEventActionConfigType;

export type EABActionTypeType = EABEventActionConfigType;

export function getEventPrefix(eventTypes: EABEventTypeType[], eventTypeId?: number): string {
  return eventTypes.find((et) => et.id === eventTypeId)?.prefix ?? "I";
}

export function getActionPrefix(actionTypes: EABActionTypeType[], actionTypeId?: number): string {
  return actionTypes.find((et) => et.id === actionTypeId)?.prefix ?? "T";
}

export function getUserName(users: { id: number; preferredName: string }[], userId: number) {
  const user = users.find((u) => u.id === userId);
  return user?.preferredName ?? "N/A";
}

export function getCardsForRevision(cards: EABEventActionTypeCard[] | undefined, revision: number) {
  return (cards ?? [])
    .filter(
      (card) =>
        card.validSinceRevision <= revision &&
        (card.removedByRevision == null || card.removedByRevision > revision),
    )
    .sort((a, b) => a.rowIndex - b.rowIndex);
}

export function formatActionEventInfoText(fieldName?: string | null) {
  const normalized = fieldName?.trim();
  return normalized == null || normalized === "" ? undefined : normalized;
}

export function getTypeFieldName(fieldId: number | undefined) {
  return `Custom Field ${fieldId}`; // TODO: Placeholder for actual custom field name retrieval logic
}
